import { Divider, Grid, Paper } from "@mui/material";
import { action, API, controller } from "api";
import { AppContext } from "App";
import { Button, Input, InputAuto, InputDate } from "controls";
import { Model, RmvEmptyProp, ToFormData, UseForm } from "hooks";
import { Alert, Form } from "layout";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const AddEditInquiry = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { InquiryMdl } = Model();
  const { setLoader } = useContext(AppContext);
  const [loading] = useState(false);
  const [inqSrcs, setInqSrcs] = useState([]);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
    handleInpDate,
  } = UseForm(InquiryMdl);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    id &&
      API(controller.Inquiry + action.GetById).getById(id, (res) => {
        if (res && res.status === 200 && res.result)
          setValues((x) => ({ ...x, ...RmvEmptyProp(res.result) }));
      });
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    API(controller.InqSrc + action.GetAllByOrg).get(
      (res) =>
        res?.status === 200 &&
        setInqSrcs([...res.result.map((j) => ({ ...j, label: j.name }))])
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateForm = () => {
    let temp = {};
    temp.fullName = values.fullName !== "" ? "" : "Full name is required.";
    temp.phone = values.phone !== "" ? "" : "Phone is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoader(true);
      const onComplete = (res) => {
        setLoader(false);
        if (res && (res.status === 201 || res.status === 200)) {
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: res?.msg,
            onClick: () => navigate("/inquiries"),
          });
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res?.msg,
          });
      };
      if (values.id === 0) {
        API(controller.Inquiry + action.Post).post(
          ToFormData({ ...values, createDate: new Date().toISOString() }),
          onComplete
        );
      } else
        API(controller.Inquiry + action.Put).put(
          ToFormData({ ...values, updateDate: new Date().toISOString() }),
          onComplete
        );
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="flex justify-between items-center p-[8px]">
            <div>
              <span className=" font-medium text-[18px] ml-[5px] text-gray-500 uppercase border-left">
                {id ? "Edit" : "Add"} Inquiry
              </span>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {id ? "Save Changes" : "Submit"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-[15px]">
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <Input
                  label="Full Name"
                  name="fullName"
                  required={true}
                  value={values.fullName}
                  error={errors.fullName}
                  onChange={handleInpChg}
                  inputProps={{ maxLength: 250 }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label="Phone"
                  name="phone"
                  required={true}
                  value={values.phone}
                  error={errors.phone}
                  onChange={handleInpChg}
                  inputProps={{ maxLength: 100 }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label="Email"
                  name="email"
                  value={values.email}
                  error={errors.email}
                  onChange={handleInpChg}
                  inputProps={{ maxLength: 200 }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputDate
                  label="Inquiry Date"
                  name="inqDate"
                  value={values.inqDate}
                  error={errors.inqDate}
                  onChange={(date) =>
                    handleInpDate("inqDate", new Date(date).toISOString())
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputAuto
                  label="Source Of Inquiry"
                  name="inquerySourceId"
                  value={values.inquerySourceId}
                  error={errors.inquerySourceId}
                  onChange={handleInpChg}
                  options={inqSrcs}
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  label="Remark"
                  name="remark"
                  value={values.remark}
                  error={errors.remark}
                  onChange={handleInpChg}
                  multiline
                  rows={3}
                  inputProps={{ maxLength: 600 }}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Form>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditInquiry;
